export default __webpack_public_path__ + "static/media/4wed.f876d4e5.jpg";